(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["satika-sliding-banner"] && !Shopify.designMode) return;
  try {
    
  class SatikaSlidingBanner extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.satika-sliding-banner__slide'));
      this.dots = Array.from(this.querySelectorAll('.satika-sliding-banner__dot'));
      this.currentIndex = 0;
      this.effect = this.dataset.effect || 'fade';
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.timer = null;
      this.isAnimating = false;

      if (this.slides.length <= 1) return;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('mouseenter', this.pause.bind(this));
      this.addEventListener('mouseleave', this.resume.bind(this));
      this.addEventListener('focusin', this.pause.bind(this));
      this.addEventListener('focusout', this.resume.bind(this));

      if (this.autoplayEnabled && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.pause();
    }

    onClick(event) {
      const target = event.target.closest('[data-action]');
      if (!target) return;

      const action = target.dataset.action;
      if (action === 'prev') this.goTo(this.currentIndex - 1);
      if (action === 'next') this.goTo(this.currentIndex + 1);
      if (action === 'goto') this.goTo(parseInt(target.dataset.slideIndex, 10));
    }

    goTo(index) {
      if (this.isAnimating || this.slides.length === 0) return;

      const nextIndex = (index + this.slides.length) % this.slides.length;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      this.pause();

      if (this.effect === 'slide') {
        currentSlide.classList.add('is-exiting');
        currentSlide.classList.remove('is-active');
        nextSlide.classList.add('is-active');
      } else {
        currentSlide.classList.remove('is-active', 'is-exiting');
        nextSlide.classList.add('is-active');
      }

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === nextIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.currentIndex = nextIndex;

      window.setTimeout(() => {
        this.slides.forEach((slide, slideIndex) => {
          if (slideIndex !== this.currentIndex) {
            slide.classList.remove('is-active', 'is-exiting');
          }
        });
        this.isAnimating = false;
        this.resume();
      }, 600);
    }

    startAutoplay() {
      this.pause();
      this.timer = window.setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.autoplaySpeed);
    }

    pause() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    resume() {
      if (!this.autoplayEnabled || this.timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }
      this.startAutoplay();
    }
  }

  if (!customElements.get('satika-sliding-banner')) {
    customElements.define('satika-sliding-banner', SatikaSlidingBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
